var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5226_16153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5055 19.3649L11.4965 18.381C11.925 17.96 11.9161 17.273 11.4786 16.8608L6.09976 11.7728H18.9287C19.5224 11.7728 20 11.2986 20 10.7091V9.29086C20 8.7014 19.5224 8.22716 18.9287 8.22716H6.09976L11.4786 3.13916C11.9116 2.72699 11.9205 2.04002 11.4965 1.61897L10.5055 0.635044C10.0904 0.218413 9.41189 0.218413 8.99232 0.635044L0.31471 9.25095C-0.104903 9.66317 -0.104903 10.3368 0.31471 10.7534L8.99232 19.3649C9.40745 19.7816 10.086 19.7816 10.5055 19.3649Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5226_16153"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 19.3548,
    fill: "white",
    transform: "translate(0 0.322571)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.9fa1e0da.svg";
export { ForwardRef as ReactComponent };